import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { AvailableBrandInfo, type Brand } from '@entities/Address'

import { useModalStore } from '@features/modal'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'

import styles from './SelectBrandModal.module.scss'

interface SelectBrandModalProps {
  brands: AvailableBrandInfo[];
  selectedBrand: Brand | null;
  onSelect: (brand: Brand) => void;
}

export default function SelectBrandModal ({
  brands,
  selectedBrand,
  onSelect,
}: SelectBrandModalProps) {
  const { t: tc } = useTranslation('common')
  const { closeModal } = useModalStore()

  const handleSelectBrand = (brand: Brand) => {
    onSelect(brand)
    closeModal('selectBrand')
  }

  return (
    <div className={styles['brand-modal']}>
      <div className={styles['brand-modal__list']}>
        {brands.map((item) => {
          const isSelected = selectedBrand?.id === item.brandInfo.id

          return (
            <div
              key={`brand-${item.brandInfo.id}`}
              className={cn(
                styles['brand-modal__item'],
                isSelected && styles['brand-modal__item--selected'],
              )}
              onClick={() => handleSelectBrand(item.brandInfo)}
            >
              <div className={styles['brand-modal__logo']}>
                {item.brandInfo.logo?.url ? (
                  <img
                    src={item.brandInfo.logo.url}
                    alt={item.brandInfo.name}
                    loading="lazy"
                  />
                ) : (
                  <div className={styles['brand-modal__logo-placeholder']}>
                    {item.brandInfo.name.charAt(0)}
                  </div>
                )}
              </div>
              <div className={styles['brand-modal__info']}>
                <span className={styles['brand-modal__name']}>
                  {item.brandInfo.name}
                </span>
                {item.nearestSlot && (
                  <span className={styles['brand-modal__slot']}>
                    {item.nearestSlot.slotDate} {item.nearestSlot.slotTime}
                  </span>
                )}
                {item.delivery_cost !== null && (
                  <span className={styles['brand-modal__cost']}>
                    {tc('deliveryCost')}:{' '}
                    {item.delivery_cost === 0
                      ? tc('free')
                      : formatPrice(item.delivery_cost)}
                  </span>
                )}
              </div>
              {isSelected && (
                <div className={styles['brand-modal__check']}>
                  <ReactSVG src="/icons/check.svg" wrapper="span" />
                </div>
              )}
            </div>
          )
        })}
      </div>
      <div className={styles['brand-modal__actions']}>
        <Button
          theme="grey"
          onClick={() => closeModal('selectBrand')}
        >
          {tc('cancel')}
        </Button>
      </div>
    </div>
  )
}
